import s from "../../../Components/account/Account.module.css";
import sended from "../../../img/sendRequest.svg";
import React from "react";


const IsSended = (props) => {
    return (
        <div className={s.requestSended}>
            <img src={sended} alt=""/>
            <p>{props.message}</p></div>
    )
}

export default IsSended;